import styled from "styled-components";

const InfoView = ({
	title = "No data to show",
	description = "There is currently no data to show in this list.",
	icon,
	children,
}) => {
	return (
		<Wrapper className="section-placeholder">
			<div className="placeholder-content search-engine">
				<img
					className="light-image"
					src={
						icon ||
						require("../assets/img/illustrations/placeholders/search-4.svg")
							.default
					}
					alt=""
					style={{ width: "100%" }}
				/>
				<h3 className="dark-inverted">{title}</h3>
				<p>{description}</p>
				{children}
			</div>
		</Wrapper>
	);
};

export default InfoView;

const Wrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
	width: 100%;
`;
